import React from 'react';

const INLINE = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)\s]+\)|https?:\/\/[^\s)]+)/g;

const inline = (text) =>
  text.split(INLINE).map((part, i) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) return <strong key={i}>{part.slice(2, -2)}</strong>;
    const link = part.match(/^\[([^\]]+)\]\(([^)\s]+)\)$/);
    const href = link ? link[2] : /^https?:\/\//.test(part) ? part : null;
    if (href) return <a key={i} href={href} target="_blank" rel="noopener noreferrer" className="text-sky-700 underline break-all">{link ? link[1] : part}</a>;
    return part;
  });

export const MiniMarkdown = ({ text }) => {
  const blocks = [];
  let list = null;
  const flush = () => { if (list) blocks.push(list); list = null; };
  (text || '').split('\n').forEach((raw, i) => {
    const line = raw.trimEnd();
    const bullet = line.match(/^\s*[-*•]\s+(.*)/);
    const num = line.match(/^\s*(\d+)[.)]\s+(.*)/);
    if (bullet || num) {
      const ordered = !!num;
      if (!list || list.ordered !== ordered) { flush(); list = { ordered, items: [], key: i }; }
      list.items.push(<li key={i}>{inline(bullet ? bullet[1] : num[2])}</li>);
      return;
    }
    flush();
    const h = line.match(/^#{1,4}\s+(.*)/);
    if (h) blocks.push(<p key={i} className="font-bold text-slate-900 mt-2">{inline(h[1])}</p>);
    else if (line.trim()) blocks.push(<p key={i}>{inline(line)}</p>);
  });
  flush();
  return (
    <div className="space-y-2 text-[14px] leading-relaxed">
      {blocks.map((b) => (b.items
        ? React.createElement(b.ordered ? 'ol' : 'ul', { key: `l${b.key}`, className: `${b.ordered ? 'list-decimal' : 'list-disc'} pl-5 space-y-1` }, b.items)
        : b))}
    </div>
  );
};
